import { AxiosResponse } from "axios";
import { axiosInstance } from "../services/axiosInstance";

export const getOnlinePresence = async (
  locationId: number | string
): Promise<AxiosResponse> => {
  return await axiosInstance.get(`salon/${locationId}/online-profile`);
};

export const updateOnlinePresence = async (
  locationId: number | string,
  formData: FormData
): Promise<AxiosResponse> => {
  return await axiosInstance.post(
    `salon/${locationId}/online-profile?_method=put`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
      // data: formData,
    }
  );
};

export const updateSalonLink = async (
  locationId: number,
  body: {
    link_type: string;
    value: 1 | 0;
  }
): Promise<AxiosResponse> => {
  return await axiosInstance.post(
    `salon/locations/${locationId}/update-link`,
    body
  );
};

export const uploadLocationDocuments = async (
  locationId: number,
  body: FormData
): Promise<AxiosResponse> => {
  return await axiosInstance.post(
    `salon/locations/${locationId}/upload-documents`,
    body,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};
